import { useMutation } from '@tanstack/react-query';
import { templateService } from '../services/templateService';

/**
 * Hook mutation para gerar HTML via IA
 * templateId é opcional — funciona tanto na criação quanto na edição
 */
export const useGenerateHtml = () => {
  return useMutation({
    mutationFn: ({ instructions, currentHtml, templateId }: {
      instructions: string;
      currentHtml: string;
      templateId?: string;
    }) => templateService.generateHtml({ instructions, currentHtml }, templateId),
  });
};
